import forOwn from 'mout/object/forOwn'
import { EFAULT } from 'constants';

export default function tallyLicenses (license) {
  const { licensedUsers } = license
 
  let count = 0
  forOwn(licensedUsers, val => {
    if (val) count++
  })
  return count
}

/* Takes licensed users and returns its length */
export function tallyLicensedUsers (licensedUsers, addOrRemove) {
  let countForTrue = 0;
  let countForFalse = 0;
  forOwn(licensedUsers, val => {
    if(!!val)
    {
      countForTrue++;
    }
    else {
      countForFalse++;
    }
  })
  if(addOrRemove)
  return countForTrue
  else 
  return (countForFalse * -1)
}
/**Takes licensedId and checks if it exists in users licenses, returns count of how many times it appears there */
export function tallyLicenseInUserLicenses(licenseId,users){
  let tallyLicenseInUserLicensesResult = {
    count:0,
    totalLength:0
  };
  forOwn(users,user => {
    if(user.licenses)
    {
      if(user.licenses[licenseId]) 
      tallyLicenseInUserLicensesResult.count++
    }
    
    tallyLicenseInUserLicensesResult.totalLength++
  })
  return tallyLicenseInUserLicensesResult;
}


// WEBPACK FOOTER //
// ./src/helpers/users/licenses/tallyLicenses.js